import { api } from '@fno/service/global.js'

export const sessionLogout = () => api
    .post('/v2/authentication/sessionLogout')
    .then(() => {
        window.location.pathname = '/app'
        window.location.hash = '/login'
        window.location.reload(false)
    })
